import React from "react";
import { Input, Stack, Text } from "@chakra-ui/react";
import { Required } from "./Required";

export const NumberInput = (props: {
  label: string;
  value: string;
  field: string;
  required: boolean;
  error: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: (field: string, value: string) => void;
}) => {
  return (
    <Stack spacing="4" mt="2" mb="1">
      <Text>
        {props.label}
        {props.required && <Required />}
      </Text>
      <Input
        onWheel={(e) => e.target.blur()}
        required={props.required}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        type="number"
        value={props.value}
        onChange={(e) => props.onChange(props.field, e.target.value)}
      />
      <Text color="red.500">{props.error}</Text>
    </Stack>
  );
};
